var _rect, _path, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.593994,
    y: 0.399643,
    width: 46.1121,
    height: 46.1121,
    rx: 10.8499,
    fill: "url(#paint0_linear_742_776)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8217 14.2786L29.9297 14.2065C30.0513 14.2044 30.1505 14.3036 30.1483 14.4252L30.0763 18.5332M29.9243 14.4306L24.079 20.2759L19.8066 19.8647L15.0873 24.584",
    stroke: "#F8F8F8",
    strokeWidth: 1.35624,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5815,
    cy: 28.9163,
    r: 6.06738,
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_742_776",
    x1: 0.593994,
    y1: 23.4557,
    x2: 46.7061,
    y2: 23.4557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9353F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED5D65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthicon);
export default __webpack_public_path__ + "static/media/growthicon.ca6d75d307f9c505fb1a5c7245fc4a90.svg";
export { ForwardRef as ReactComponent };